// src/utils/dashboardApi.js
//
// Talks to /api/login, /api/logout, /api/analytics/dashboard.
// Frontend and backend now live on the same Vercel domain (backend is
// implemented as Vercel Serverless Functions under /api), so these are
// plain relative fetches — no cross-origin CORS, no REACT_APP_API_BASE_URL
// needed. credentials: "include" still matters locally when using
// `vercel dev`, and is harmless in production.

export async function loginToDashboard(password) {
  const res = await fetch(`/api/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Login failed");
  return data;
}

export async function logoutOfDashboard() {
  await fetch(`/api/logout`, {
    method: "POST",
    credentials: "include",
  });
}

export async function fetchDashboardData(days = 28) {
  const res = await fetch(`/api/analytics/dashboard?days=${days}`, {
    credentials: "include",
  });

  if (res.status === 401) {
    const err = new Error("Not authenticated");
    err.unauthorized = true;
    throw err;
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load dashboard data");
  return data;
}
